const DOMAIN_MAPPINGS: Record<string, string> = {
  'dev2-app.upstackified.com': 'dev-app.upstackdata.com',
  'qa2-app.upstackified.com': 'qa-app.upstackdata.com',
  'app2.upstackified.com': 'app.upstackdata.com',
};

export { DOMAIN_MAPPINGS };
